import styled from 'styled-components';

export const Spacer = styled.em`
  width: var(--spacer-2);
`;
